import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { finalize } from "rxjs/operators";
import { vGlobal } from "@core/types/cb-global-vars";
import { manageStorageService } from "@core/services/manage-storage/manage-storage.service";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { geolocalizationService } from '@core/services/geolocalization';


@Injectable()
export class HttpBodyInterceptor implements HttpInterceptor {

  constructor(private _mStorage: manageStorageService, private _geoS: geolocalizationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let wsName: string = request.url.split("/").pop(),
      s_token: string = sessionStorage.getItem("s_token"),
      rqPost: boolean = (request.method === "POST");

 

    return next.handle(request).pipe(
      finalize(() => {
        
      })
    )

  }
}